import { useContext, useEffect, useRef, useState } from 'react'
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import slugify from 'slugify';
import Carousel from 'react-multi-carousel';
import axios from 'axios';
import { ConfigContext } from '../../../Context/ConfigContext';
import Tabs from './Tabs';
import useIsMobile from '../../../Helper/useIsMobile';
import MobSection from './MobSection';
import { Helmet } from 'react-helmet';
import RecentViews from '../../Home/RecentViews';
import CarInfoBox from '../../Cars/CarInfoBox';
import ShopByBrands from '../../Home/ShopByBrands';
import { OverlayLoader } from '../../../Components/Shimmers';
import { axiosGet } from '../../../Apis/axiosMethods';

const Catelog = () => {

  const { t } = useTranslation();
  const locale = localStorage.getItem('lang');
  const {
    gdcURL,
    PCID,
    setCategories,
    categories,
    treeCategories,
  }
    = useContext(ConfigContext);
  const dir = localStorage.getItem('dir');

  const [p_subs, setPsubs] = useState(null);
  const [p_index, setPindex] = useState(0);
  const [p_title, setPTitle] = useState(null);
  const [p_STR_ID, setPSTRID] = useState(null);

  const [loading, setLoading] = useState(true);
  const { s_str_id } = useParams();
  const [stridtree, setSTRIDTree] = useState(s_str_id ? [Number(s_str_id), null] : [null]);

  const [starDepartments, setStartDepartment] = useState([]);
  const [responsive] = useState({
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
      slidesToSlide: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 1
    }
  })

  const fetchCategories = async () => {
    window.scrollTo(0, 0);

    const storedPCID = localStorage.getItem('pc_id');

    try {
      setLoading(true);

      let response;

      if (storedPCID && storedPCID !== '' && storedPCID !== '0') {
        response = await axiosGet(`/Parts/GetCategoriesByCar?pc_id=${PCID}&lang=en`);
      } else {
        response = await axiosGet(`/Parts/GetCategories?lang=en`);
      }

      setCategories(response.data.data);
    } catch (err) {
      console.error("Category Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    fetchCategories();
  }, [PCID, locale]);


  useEffect(() => {
    var tempstarDepartments = [];
    treeCategories.map((item) => {
      if (item.STR_ID === 100002) {
        tempstarDepartments.push(item);
        if (item.children.length > 0) {
          item.children.map((child) => {
            tempstarDepartments.push(child);
            child.children.map((child2) => {
              tempstarDepartments.push(child2);
            });
          });
        }
      }
    })

    setStartDepartment(tempstarDepartments);
  }, [treeCategories])

  const RemoveCategorySTRID = () => {
    if (stridtree[0] !== null) {
      setSTRIDTree(stridtree.slice(1));
    }
  }

  const car_info = localStorage.getItem('car_info') ? JSON.parse(localStorage.getItem('car_info')) : null;

  const handleShow = (subs, title, STR_ID, index) => {
    setPTitle(title);
    setPsubs(subs);
    setPSTRID(STR_ID);
    setPindex(Math.floor(((index) / 6)));
  }

  const isMobile = useIsMobile();
  const [showAllCategories, setShowAllCategories] = useState(false);

  return (
    <>
      {loading ? (
        <div style={{ height: "70vh" }}>
          <OverlayLoader />
        </div>
      )
        :
        <main className="main" style={{ marginTop: '-10px', textAlign: dir === 'rtl' ? 'right' : 'unset' }} dir={dir} >
          <Helmet>
            <title>{t('spare_parts_catelogue')}</title>
          </Helmet>
          <CarInfoBox />

          <div className={isMobile ? '' : 'p-5'} >
            <div className="container" >
              {loading === false &&
                categories &&
                categories.length > 0 &&
                treeCategories &&
                treeCategories.length > 0 &&
                (
                  <center
                    className='mb-4'>
                    <h3
                      style={{
                        fontWeight: 500,
                        textTransform: 'uppercase'
                      }}>
                      {car_info ?
                        t('choose_car_parts_category_for', { car: car_info[0].TYPEL })
                        :
                        t('choose_car_parts_category')}
                    </h3>
                  </center>
                )}

              <center>
                {loading === false && categories && categories.length === 0 && (
                  < div
                    style={{
                      minHeight: '300px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '20px'
                    }}
                  >
                    <span
                      role="img"
                      aria-label="car"
                      style={{
                        fontSize: 32,
                        marginBottom: 0
                      }}
                    >
                      <svg
                        class="svg-icon"
                        style={{
                          width: '5em',
                          height: '5em',
                          verticalAlign: 'middle',
                          fill: 'currentColor',
                          overflow: 'hidden'
                        }}
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M513.6 72C265.6 72 65.6 272 65.6 518.4c0 246.4 200 446.4 446.4 446.4C760 966.4 960 764.8 960 518.4 960 272 760 72 513.6 72zM513.6 934.4c-228.8 0-414.4-185.6-414.4-414.4S284.8 104 513.6 104 928 289.6 928 518.4 742.4 934.4 513.6 934.4z" /><path d="M350.4 347.2m-62.4 0a3.9 3.9 0 1 0 124.8 0 3.9 3.9 0 1 0-124.8 0Z" /><path d="M670.4 347.2m-62.4 0a3.9 3.9 0 1 0 124.8 0 3.9 3.9 0 1 0-124.8 0Z" /><path d="M296 672l17.6 25.6c1.6-1.6 192-131.2 396.8 0l17.6-27.2C505.6 528 297.6 670.4 296 672z" /></svg></span>

                    <br />

                    <h3 style={{ lineHeight: '0' }}>Unfortunately, </h3> <br />
                    <strong>there are no parts currently in stock for the selected car.</strong>
                    Please try another car or check back soon.

                  </div>
                )}
              </center>

              {loading === false &&
                categories &&
                categories.length > 0 &&
                treeCategories &&
                treeCategories.length > 0 &&
                <div className={`container ${treeCategories.length}`}>
                  <Carousel
                    swipeable={true}
                    draggable={false}
                    showDots={false}
                    responsive={responsive}
                    infinite={false}
                    autoPlaySpeed={1000}
                    keyBoardControl={true}
                    customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px">
                    {
                      treeCategories &&
                      treeCategories.map((item, indexxx) => {
                        return item.children && <div >
                          <div className={isMobile ? 'mr-1' : 'p-5 mr-4'} style={{ backgroundColor: '#f5f5f5', height: '500px', overflow: 'hidden' }} >
                            <div style={{ minHeight: '100px' }}>
                              <img
                                src={`${gdcURL}/category-images/600x600/${item.STR_ID}`}
                                className="img-fluid"
                                height={100}
                                alt={item.STR_NODE_NAME}
                                onClick={() => handleShow(item.children, item.STR_NODE_NAME, item.STR_ID, indexxx)}
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null;
                                  currentTarget.src = "https://placehold.co/100x100/FFFFFF/FFFFFF/png";
                                  currentTarget.height = 100
                                }} />
                            </div>
                            <div style={{ position: 'relative' }}>
                              <hr style={{ lineHeight: 0, margin: 0 }} />
                              <div style={{
                                position: 'absolute',
                                left: '50%',
                                top: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: '#cc000a'
                              }}></div>
                            </div>
                            <center><div className='mt-2' style={{ fontSize: 'large', color: '#000', height: '50px' }}>{item.STR_NODE_NAME}</div></center>
                            <br />
                            <ul style={{ lineHeight: '25px', listStyleType: 'disc', paddingLeft: dir === 'rtl' ? '' : '20px', paddingRight: dir === 'rtl' ? '20px' : '' }} dir={dir}>
                              {item.children &&
                                [...new Map(item.children.map(child => [child.STR_NODE_NAME, child])).values()]
                                  .slice(0, 5)
                                  .map((child) => (
                                    <li key={child.STR_ID} style={{ color: '#cc000a' }}>
                                      <span style={{ color: 'inherit' }}>
                                        <NavLink
                                          to={
                                            localStorage.getItem('pc_id')
                                              ? `/Spare-Parts/${slugify(item.STR_NODE_NAME)}-${item.STR_ID}`
                                              : `/Spare-Parts/Spare-Parts-nocar/${item.STR_ID}/${slugify(item.STR_NODE_NAME)}`
                                          }
                                          className="nav-link-custom"
                                          style={{ color: '#000' }}
                                        >
                                          {child.STR_NODE_NAME}
                                        </NavLink>
                                      </span>
                                    </li>
                                  ))
                              }
                            </ul>
                          </div>
                        </div>
                      })
                    }
                  </Carousel>
                </div>

              }
              {isMobile && <section className="feature-boxes-container" style={{ background: '#FFF' }}>
                <h3 style={{ fontWeight: 500 }}>{car_info ? t('please_choose_proper_group', { value: car_info[0].TYPEL }) : t('ghayar_original_spare_parts')}</h3>
                <MobSection />
              </section>}

              <div className="flex-wrap d-flex justify-content-between align-items-center">
                {
                  stridtree[0] !== null ? <h4 onClick={() => RemoveCategorySTRID()}> <i className="fas fa-arrow-left mr-3 my-icon"></i>{" "} </h4> : <div></div>
                }
              </div>

              {loading === false && isMobile === false && categories && categories.length > 0 &&
                <section className="feature-boxes-container" style={{ background: '#FFF' }}>
                  <h3 style={{ fontWeight: 500 }}>{car_info ? t('please_choose_proper_group', { value: car_info[0].TYPEL }) : t('ghayar_original_spare_parts')}</h3>
                  <div className="container" data-animation-name="fadeInUpShorter" >
                    <Tabs p_index={p_index} p_subs={p_subs} p_title={p_title} p_STR_ID={p_STR_ID} />
                  </div>
                </section>
              }

              {
                car_info && treeCategories && treeCategories.map((item, indexxx) => {
                  if (item.STR_ID === 100002) {
                    return <h3 style={{ fontWeight: 500, marginTop: "20px" }}>{t('car_department_catalogue', { car: car_info[0].TYPEL, department: item.STR_NODE_NAME })}</h3>
                  }
                })
              }

              <div className='row'>
                {
                  starDepartments && starDepartments.slice(0, showAllCategories ? starDepartments.length : 4).map((child) => (
                    <div className='col-sm-3' key={child.STR_ID}>
                      <NavLink
                        to={localStorage.getItem('pc_id') ? `/Spare-Parts/${slugify(child.STR_NODE_NAME)}-${child.STR_ID}` : `/Spare-Parts/Spare-Parts-nocar/${child.STR_ID}/${slugify(child.STR_NODE_NAME)}`}
                        className="nav-link-custom"
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <img
                          alt={child.STR_NODE_NAME}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = "https://placehold.co/100x100/FFFFFF/FFFFFF/png";
                          }}
                          src={`${gdcURL}/category-images/600x600/${child.STR_ID}`}
                          style={{ width: '100px', marginRight: '10px' }} />
                        {child.STR_NODE_NAME}
                      </NavLink>
                    </div>
                  ))
                }
              </div>

              {treeCategories && treeCategories.some(item => item.STR_ID === 100002 && item.children.length > 4) && (
                <div className="text-center mt-3">
                  <button
                    className="btn btn-link"
                    onClick={() => setShowAllCategories(!showAllCategories)}
                    style={{ textDecoration: 'none' }}
                  >
                    {showAllCategories ? t('show_less') : t('show_more')}
                    <i style={{ marginRight: dir === 'rtl' ? '10px' : 'unset' }} className={`fas fa-chevron-${showAllCategories ? 'up' : 'down'} ml-2`}></i>
                  </button>
                </div>
              )}

              <br />


              <ShopByBrands />

              <RecentViews />
            </div>
          </div>
        </main>
      }

    </>
  )

}

export default Catelog;